import { LoadingScreen } from "components/LoadingScreen";
import { FiltrosAguardando } from "./containers/FiltrosReprovados";
import { ListarReprovados } from "./containers/ListarReprovados";
import { useProcessoFinanceiroAprovar } from "../../../hooks/useProcessoFinanceiroAprovar";
import { useEffect, useState } from "react";
import { ContainerFiltros } from "./style";
import { IFiltrosPagamentosReprovados } from "../../../interface/IFiltrosPagamentosReprovados";

interface IProps {
  aba: string;
}

export function TabReprovados({ aba }: IProps) {
  const {
    dadosReprovados,
    totalRows,
    limit,
    page,
    loading,
    setLimit,
    setPage,
    listarReprovados,
    idLoteEscolhido,
    setIdLoteEscolhido,
    dadosDetalhes,
    setDadosDetalhes,
    buscarDetalhesLotePagamento,
    buscarEstatisticasLotePagamento,
    buscarEstatisticasPagamento,
    onClickProcesso,
    relatorioDetalhado,
    numeroNfReciboEscolhido,
    buscarComprovantes,
    selectedRows,
    buscarReciboNf,
    filtroListaReprovados,
  } = useProcessoFinanceiroAprovar();
  function handlePageChange(page: number) {
    setPage(page);
  }
  function handleLimitChange(limit: number) {
    setLimit(limit);
  }
  const [showModalDetalhesLotePagamento, setShowModalDetalhesLotePagamento] =
    useState<boolean>(false);
  const [valorTotalLoteEscolhido, setValorTotalLoteEscolhido] = useState<
    number | null
  >(null);

  useEffect(() => {
    if (aba !== "reprovados") return;

    listarReprovados(filtroListaReprovados);
  }, [aba, limit, page, filtroListaReprovados]);

  const submitFiltro = (dados: IFiltrosPagamentosReprovados) => {
    listarReprovados(dados);
  };

  const handleCloseModalDetalhes = () => {
    setShowModalDetalhesLotePagamento(false);
    setDadosDetalhes([]);
    setIdLoteEscolhido(null);
    setValorTotalLoteEscolhido(null);
  };

  const onClickVerDetalhes = (idLote: number) => {
    setIdLoteEscolhido(idLote);
    setValorTotalLoteEscolhido(
      dadosReprovados.find((item) => item.id == idLote)?.valorNfRecibo ?? null,
    );
  };

  useEffect(() => {
    if (idLoteEscolhido) {
      buscarDetalhesLotePagamento();
      setShowModalDetalhesLotePagamento(true);
      return;
    }
  }, [idLoteEscolhido]);

  const onClickVerReciboNf = (idLote: number, numeroNfRecibo: string) => {
    buscarReciboNf(idLote, numeroNfRecibo);
  };

  return (
    <ContainerFiltros>
      <LoadingScreen mostrar={loading} />
      <FiltrosAguardando submitForm={submitFiltro} />
      <ListarReprovados
        dados={dadosReprovados}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRows}
        loadingLista={false}
        linhasPorPagina={limit}
        showModalDetalhesLotePagamento={showModalDetalhesLotePagamento}
        dadosDetalhes={dadosDetalhes}
        handleCloseModalDetalhes={handleCloseModalDetalhes}
        numeroNfReciboEscolhido={numeroNfReciboEscolhido}
        onClickVerDetalhes={onClickVerDetalhes}
        buscarEstatisticasLotePagamento={buscarEstatisticasLotePagamento}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        valorTotalLoteEscolhido={valorTotalLoteEscolhido}
        onClickProcesso={onClickProcesso}
        relatorioDetalhado={relatorioDetalhado}
        buscarComprovantes={buscarComprovantes}
        selectedRows={selectedRows}
        onClickVerReciboNf={onClickVerReciboNf}
        aba={aba}
      />
    </ContainerFiltros>
  );
}
